import { GET_USER_FAILURE, GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_CLEAR, GetUserActionTypes, GetUserState } from './types';

const defaultState: GetUserState = {
  isLoading: false,
  errorMessage: "",
};

export default function getUser(state = defaultState, action: GetUserActionTypes): GetUserState {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_USER_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
